/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class Previewer extends Component {
  amiAvatarImage = new URL('cio/assets/images/ami-avatar.png', import.meta.url).toString();
  avatarOutlineImage = new URL('cio/assets/images/avatar-outline.png', import.meta.url).toString();
}
